import React, { type FC } from 'react';
import { DayContent, type DayContentProps } from 'react-day-picker';
import getClassName from 'src/common/utils/getClassName';
import classNames from 'classnames';
import Icon from 'src/common/components/IconDS22';
import useBookingMotivatorsContext from 'src/common/hooks/useBookingMotivators';
import { formatDate } from 'src/common/utils/dateHelpers';
import s from './DayContentWithMotivators.module.scss';

/** Optional custom day content to use via `DayPicker['components']['DayContent']` */
const DayContentWithMotivators: FC<DayContentProps> = ({ date, displayMonth, activeModifiers }) => {
  const { bookingMotivators } = useBookingMotivatorsContext();
  const motivators = bookingMotivators[formatDate(date)] ?? [];

  return (
    <div className={getClassName(s, 'root', classNames(motivators))}>
      {motivators.includes('UNAVAILABLE') && activeModifiers.selected && (
        <div className={s.warningIcon}>
          <Icon id="warning" size="s" />
        </div>
      )}
      {motivators.includes('IN_DEMAND') && (
        <span className={s.IN_DEMAND} />
      )}
      <DayContent
        date={date}
        displayMonth={displayMonth}
        activeModifiers={activeModifiers}
      />
    </div>
  );
};
export default DayContentWithMotivators;
